<template>
  <div class="create-challenge-element container-fluid">
    <div id="myNav" class="overlay overlay-overall-width-100Perc">
      <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
        <div class="row margin-left-1Point6Perc">
          <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc create-element-overlay-course-title-font-styles">
            {{getCurrentlySelectedCourseObj.CourseTitle}}
          </div>
          <div class="col-md-5 col-lg-5">
            <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="udpateCloseCreateElementOverlay($event,false)">
              <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
            </div>
          </div>
        </div>
        <div class="row margin-left-1Point5Perc padding-bottom-1Perc bottom-border margin-bottom-2Perc">
          <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
            {{lessonObj.Title}}
          </div>
        </div>
        <div class="row vertical-align margin-bottom-0Point5Perc">
          <div class="col-md-1 col-lg-1">
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Title
            <!-- Index -->
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="text" class="form-control" v-model="ChallengeTitleValue" :maxlength="maxLength">
              </div>
            </div>
          </div>
          <!-- Allowed Response Types -->
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Allowed Response Types
          </div>
          <div class="col-md-4 col-lg-4">
            <label :class="{'cursor-default' : ChallengeAllocateManuallyFlag}" class="checkbox-inline col-lg-4 margin-left-0px"><input type="checkbox" value=0 v-model="allowedResponseTypeArr" :disabled="ChallengeAllocateManuallyFlag">Video</label>
            <label :class="{'cursor-default' : ChallengeAllocateManuallyFlag}" class="checkbox-inline col-lg-4 margin-left-0px"><input type="checkbox" value=1 v-model="allowedResponseTypeArr" :disabled="ChallengeAllocateManuallyFlag">Audio</label>
            <label :class="{'cursor-default' : ChallengeAllocateManuallyFlag}" class="checkbox-inline col-lg-4 margin-left-0px"><input type="checkbox" value=2 v-model="allowedResponseTypeArr" :disabled="ChallengeAllocateManuallyFlag">Text</label>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>
        </div>
        <div class="row vertical-align margin-bottom-1Point5Perc">
          <div class="col-md-1 col-lg-1">
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Duration
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="text" class="form-control" v-model="ChallengeDurationValue" placeholder="MM:SS">
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Faculty Response Video Url
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <video-quality-control :parentElementObj="videoUrlObj" :currQualityType="constants.Video_Quality.Q_360" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control>
                <video-quality-control :parentElementObj="videoUrlObj" :currQualityType="constants.Video_Quality.Q_Auto" :disableInputBox="false" @updatedValue="updateVideoQualityValue"></video-quality-control>
                <video-quality-control :parentElementObj="videoUrlObj" :currQualityType="constants.Video_Quality.Q_720" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control>
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>
        </div>
        <div class="row vertical-align margin-bottom-2Perc">
          <div class="col-md-1 col-lg-1">
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Challenge
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <select class="form-control" v-model="ChallengeIdValue">
                  <option value='-1' disabled>Select</option>
                  <option v-for="singleChallengeObj in this.$store.state.challengeList" v-bind:key="singleChallengeObj.ChallengeId" v-bind:value="singleChallengeObj.ChallengeId">{{ singleChallengeObj.Title }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Caption File
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="file" id="vttFile" accept=".vtt">
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>
        </div>
        <div class=" row vertical-align margin-bottom-2Perc">
          <div class="col-md-1 col-lg-1">
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
          Feedback Type
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <select class="form-control" v-model="ChallengeFeedbackTypeValue">
                  <option value=-1 disabled>Select</option>
                  <option value=0 :disabled="ChallengeSubTypeValue == 1">Regular</option>
                  <option value=1>Self</option>
                </select>
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
          Sub Type
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <select class="form-control" v-model="ChallengeSubTypeValue">
                  <option value='-1' disabled>Select</option>
                  <option value='0'>Normal</option>
                  <option value='1' :disabled="ChallengeFeedbackTypeValue==0">Teachback</option>
                </select>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-4 col-lg-4" v-if="false">
            <div class="form-group">
              <div class="col-sm-12 cursor-pointer" @click="ShowRtfEditorOverlayFlag($event,true)">
                + Add Teachback Description
              </div>
            </div>
          </div> -->
          <div class="col-md-1 col-lg-1">
          </div>
        </div>
        <div class="row vertical-align margin-bottom-2Perc" v-if="(this.elementObj.SubType == 1)">
          <div class="col-md-1 col-lg-1">
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Teachback Description
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <span class="cursor-pointer" @click="ShowRtfEditorOverlayFlag($event,true)">+ RTF Text</span>
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-left padding-right-0Px font-wight-bold">
            or
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="file" id="toolkitfile" accept=".pdf">
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>
        </div>
        <div class="row vertical-align margin-bottom-1Perc">
          <div class="col-md-1 col-lg-1">
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Response Duration
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-md-9 col-lg-10">
                <input type="text" class="form-control" v-model="ChallengeResponseDurationValue" maxlength="5">
              </div>
              <div class="col-md-1 col-lg-2 padding-left-0px margin-top-2Point4Perc">
                  Mins
              </div>
            </div>
          </div>
        </div>
        <div class="row vertical-align margin-bottom-1Perc">
          <div class="col-md-1 col-lg-1">
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Feedback Screens
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="checkbox">
                <label><input type="checkbox" value=1 v-model="feedbackScreens">Traffic Light</label>
                <label><input type="checkbox" value=2 v-model="feedbackScreens">Quantitative</label>
                <label><input type="checkbox" value=3 v-model="feedbackScreens" :disabled="ChallengeFeedbackTypeValue == 1">Qualitative</label>
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Max Allocation Time
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-md-9 col-lg-10">
                <input type="text" class="form-control" v-model="ChallengeMaxAllocationTimeValue" :disabled="ChallengeFeedbackTypeValue == 1" maxlength="5">
              </div>
              <div class="col-md-1 col-lg-2 padding-left-0px margin-top-2Point4Perc">
                  Mins
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>
        </div>
        <div class="row vertical-align margin-bottom-2Perc">
          <div class="col-md-1 col-lg-1">
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Max Feedback Time
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-md-9 col-lg-10">
                <input type="text" class="form-control" v-model="ChallengeMaxFeedbackTimeValue" :disabled="ChallengeFeedbackTypeValue == 1" maxlength="5">
              </div>
              <div class="col-md-1 col-lg-2 padding-left-0px margin-top-2Point4Perc">
                Mins
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Max Peer Allocation
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <select class="form-control" v-model="ChallengeMaxPeerAllocationValue" :disabled="ChallengeFeedbackTypeValue == 1">
                  <option value=-1 disabled>Select</option>
                  <option value=1>1</option>
                  <option value=2>2</option>
                  <option value=3>3</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>
        </div>
        <div class="row vertical-align margin-bottom-2Perc">
          <div class="col-md-1 col-lg-1">
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Min Peers For Feedback
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <select class="form-control" v-model="ChallengeMinPeerForFeedbackValue" :disabled="ChallengeFeedbackTypeValue == 1 || ChallengeAllocateManuallyFlag">
                  <option value=-1 >None</option>
                  <option value=1>1</option>
                  <option value=2>2</option>
                  <!-- <option value=3></option> -->
                </select>
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
                <div class="checkbox">
                  <label :class="{'cursor-default' : ChallengeFeedbackTypeValue == 1 || ChallengeAllocateManuallyFlag || ChallengeRequireFeedbackForCoachAllocationValue}"><input type="checkbox" value="true" v-model="ChallengeAlwaysAssignCoach" :disabled="ChallengeFeedbackTypeValue == 1 || ChallengeAllocateManuallyFlag || ChallengeRequireFeedbackForCoachAllocationValue">Always Assign Coach</label>
                </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>
        </div>
        <div class="row vertical-align margin-bottom-2Perc">
          <div class="col-md-1 col-lg-1">
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Max Coach Allocation Time
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-md-9 col-lg-10">
                <input type="text" class="form-control" v-model="ChallengeMaxCoachAllocationTimeValue" :disabled="ChallengeFeedbackTypeValue == 1 || ChallengeAlwaysAssignCoach || ChallengeAllocateManuallyFlag" maxlength="5">
              </div>
              <div class="col-md-1 col-lg-2 padding-left-0px margin-top-2Point4Perc">
                Mins
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
                <div class="checkbox">
                  <label :class="{'cursor-default' : ChallengeFeedbackTypeValue == 1 || ChallengeAlwaysAssignCoach || ChallengeAllocateManuallyFlag}"><input type="checkbox" value="true" v-model="ChallengeRequireFeedbackForCoachAllocationValue" :disabled="ChallengeFeedbackTypeValue == 1 || ChallengeAlwaysAssignCoach || ChallengeAllocateManuallyFlag">Require Feedback for Coach Allocation</label>
                </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>
        </div>
        <div class="row vertical-align margin-bottom-2Perc" v-if="false">
          <div class="col-md-1 col-lg-1">
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px" v-if="false">
            Element Learning Type
          </div>
          <div class="col-md-4 col-lg-4" v-if="false">
            <div class="form-group">
              <div class="col-sm-12">
                <select class="form-control" v-model="elementLearningLevelObjValue">
                  <option value=-1>None</option>
                  <option v-for="learningLevelObj in getLearningLevelList" :key="learningLevelObj.LearningLevelId" :value="learningLevelObj.LearningLevelId">{{learningLevelObj.LearningLevelName}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
                <div class="checkbox">
                  <label :class="{'cursor-default' : ChallengeFeedbackTypeValue == 1 || ChallengeAlwaysAssignCoach || ChallengeAllocateManuallyFlag}"><input type="checkbox" value="true" v-model="ChallengeRequireFeedbackForCoachAllocationValue" :disabled="ChallengeFeedbackTypeValue == 1 || ChallengeAlwaysAssignCoach || ChallengeAllocateManuallyFlag">Require Feedback for Coach Allocation</label>
                </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>
        </div>
        <div class="row vertical-align margin-bottom-2Perc">
          <div class="col-md-1 col-lg-1">
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="checkbox">
                <label :class="{'cursor-default' : ChallengeFeedbackTypeValue == 1 || ChallengeAlwaysAssignCoach}"><input type="checkbox" value="true" v-model="ChallengeAllocateManuallyFlag" :disabled="ChallengeFeedbackTypeValue == 1 || ChallengeAlwaysAssignCoach">Allocate Manually</label>
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">

          </div>
          <!-- <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="checkbox">
                <label><input type="checkbox" value="true" v-model="MCQIsPersonalization">Is personalization</label>
              </div>
            </div>
          </div> -->
          <div class="col-md-1 col-lg-1">
          </div>
        </div>
        <div class="row vertical-align margin-bottom-2Perc">
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <div class="checkbox">
                  <label><input type="checkbox" value="true" v-model="ChallengeIncludeInProgress">Include In Progress</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row margin-bottom-2Perc">
            <div class="col-md-5 col-lg-5">
            </div>
            <div class="col-md-2 col-lg-2">
            <!-- ToDo: Track this -->
              <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="validateAllFieldsBeforeCreate">Create Challenge</button>
            </div>
            <div class="col-md-5 col-lg-5">
            </div>
          </div>
          <div class="row">
          </div>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="createChallenge"></confirmation-alert>
      <add-teachback-description-overlay v-bind:addedDescription="AddDescriptionvalue" @showSpinner="updateShowSpinnerFlag" v-if="showRtfEditorDetails" @closeRtfEditorOverlay="updateShowRtfEditorFlag"></add-teachback-description-overlay>
    </div>
</template>
<script>
import { constants } from '@/utils/constants'
import { elementService } from '@/server-util/element-service'
import { challengeService } from '@/server-util/challenge-service'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import addTeachbackDescriptionOverlay from '@/components/AddTeachbackRTFDescriptionOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import VideoQualityControl from '@/components/VideoQualityControl'
export default {
  props: ['lessonObj'],
  name: 'create-challenge-element',
  created () {
    this.getChallenges()
    this.setDefaultValues()
    this.GetLearningLevels()
  },
  data: function () {
    return {
      constants: constants,
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      showAlertDialog: false,
      disableInputBoxFor360And720: true,
      errorMsg: '',
      videoUrlObj: {
        LowQualityVideoUrl: '',
        HDVideoUrl: '',
        VideoUrl: ''
      },
      elementObj: {
        ModuleId: '',
        Title: '',
        Description: null,
        Duration: '',
        Type: 1,
        Index: null,
        IncludeInProgress: false,
        AllowedResponseTypes: '',
        SubType: -1,
        IsPersonalization: false,
        ElemChallenge: {
          ChallengeId: '-1',
          FeedbackScreens: '',
          FeedbackType: -1,
          MaxFeedbackTime: 24,
          MaxCoachAllocationTime: null,
          AlwaysAssignCoach: false,
          MaxAllocationTime: 24,
          MaxPeerAllocations: 1,
          MinPeersForFeedback: 1,
          FacultyResponseVideoUrl: '',
          FacultyResponseLQVideoUrl: '',
          FacultyResponseHDVideoUrl: '',
          ResponseDuration: '5',
          AllocateManually: false,
          RequireFeedbackForCoachAllocation: false
        },
        LearningLevelId: ''
      },
      showVideoMediaController: false,
      allowedResponseTypeArr: [0],
      feedbackScreens: [1, 2, 3],
      currentlyShowingSpinner: false,
      maxLength: constants.Element_Title_Step_Max_Length,
      VideoUrl: '',
      showRtfEditorDetails: false
    }
  },
  components: {
    'alert-box': AlertBox,
    'confirmation-alert': ConfirmationOverlay,
    'add-teachback-description-overlay': addTeachbackDescriptionOverlay,
    'video-quality-control': VideoQualityControl
  },
  methods: {
    updateVideoQualityValue (value) {
      console.log('Emitted with: ', value)
      const videoUrl = value.videoUrl
      const currQualityType = value.currQualityType
      switch (parseInt(currQualityType)) {
        case parseInt(constants.Video_Quality.Q_360):
          console.log('360 ' + videoUrl)
          this.LowVideoURLValue = videoUrl
          this.FacultyResponseLQVideoUrlValue = videoUrl
          break
        default:
        case parseInt(constants.Video_Quality.Q_Auto):
          console.log('Auto ' + videoUrl)
          this.VideoURLValue = videoUrl
          this.FacultyResponseVideoUrlValue = videoUrl
          if (this.FacultyResponseVideoUrlValue.trim().length === 0) {
            this.LowVideoURLValue = ''
            this.FacultyResponseLQVideoUrlValue = ''
            this.HDVideoURLValue = ''
            this.FacultyResponseHDVideoUrlValue = ''
            this.disableInputBoxFor360And720 = true
          } else {
            this.disableInputBoxFor360And720 = false
          }
          break
        case parseInt(constants.Video_Quality.Q_720):
          console.log('720 ' + videoUrl)
          this.HDVideoURLValue = videoUrl
          this.FacultyResponseHDVideoUrlValue = videoUrl
          break
      }
    },
    validateAllFieldsBeforeCreate: function () {
      if (this.validateRequiredFieldBeforeSubmit()) {
        if (this.ChallengeFeedbackTypeValue === constants.ChallengeFeedbackType.Regular_Challenge) {
          if (this.elementObj.ElemChallenge.MaxFeedbackTime < 5 && this.elementObj.ElemChallenge.MaxAllocationTime < 5) {
            this.showConfirmationBox = true
            this.prefixString = 'Max Allocation and Feedback time should not go below 5 Mins.'
            this.postString = ' Are you sure you want to continue?'
          } else if (this.elementObj.ElemChallenge.MaxFeedbackTime < 5) {
            this.showConfirmationBox = true
            this.prefixString = 'Max Feedback time should not go below 5 Mins.'
            this.postString = ' Are you sure you want to continue?'
          } else if (this.elementObj.ElemChallenge.MaxAllocationTime < 5) {
            this.showConfirmationBox = true
            this.prefixString = 'Max Allocation time should not go below 5 Mins.'
            this.postString = ' Are you sure you want to continue?'
          } else {
            this.CreateChallengeElement()
          }
        } else {
          this.CreateChallengeElement()
        }
      }
    },
    createChallenge (values) {
      this.showConfirmationBox = false
      if (values) {
        this.CreateChallengeElement()
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    udpateCloseCreateElementOverlay: function (event) {
      this.$emit('openOverlay', false)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getChallenges: function () {
      var _this = this
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== '' &&
        storeObj.state.access_token !== null
      ) {
        if (storeObj.state.challengeList.length === 0) {
          // AK: Start showing spinner only if challenge list not found (LessonListCreateElement file)
          _this.$emit('showSpinner', true)

          // AK: Locally tracking in order to check weather it is really needed to hide spinner or not after success response
          this.currentlyShowingSpinner = true
        }

        challengeService.getAllChallenges(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.challengeList = responseObj.data
              if (this.currentlyShowingSpinner === true) {
                // AK: Hide Spinner if its showing to user
                _this.$emit('showSpinner', false)
              }
            } else {
              if (this.currentlyShowingSpinner === true) {
                // AK: Hide Spinner if its showing to user
                _this.$emit('showSpinner', false)
              }
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            if (this.currentlyShowingSpinner === true) {
              // AK: Hide Spinner if its showing to user
              _this.$emit('showSpinner', false)
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log(
          'ACCESS TOKEN is NULL hence declined GET CHALLENGE LIST OPERATION'
        )
      }
    },
    CreateChallengeElement: function () {
      var _this = this
      var storeObj = this.$store
      if (
        this.lessonObj.ModuleId !== undefined &&
        this.elementObj.ModuleId !== '' &&
        this.elementObj.ModuleId !== undefined
      ) {
        // AK: Start showing spinner (LessonListCreateElement file)
        _this.$emit('showSpinner', true)
        // AK: Sort and bind the Feeback screens
        _this.FacultyResponseVideoUrlValue = _this.FacultyResponseVideoUrlValue !== '' ? _this.FacultyResponseVideoUrlValue.trim() : ''
        _this.FacultyResponseHDVideoUrlValue = _this.FacultyResponseHDVideoUrlValue !== '' ? _this.FacultyResponseHDVideoUrlValue.trim() : ''
        _this.FacultyResponseLQVideoUrlValue = _this.FacultyResponseLQVideoUrlValue !== '' ? _this.FacultyResponseLQVideoUrlValue.trim() : ''
        _this.elementObj.ElemChallenge.FeedbackScreens = this.sortFeebackScreens()
        _this.elementObj.ElemChallenge.FeedbackScreens = this.sortFeebackScreens()
        _this.elementObj.AllowedResponseTypes = this.allowedResponseTypeArr.toString()
        _this.elementObj.ElemChallenge.ResponseDuration = parseInt(this.elementObj.ElemChallenge.ResponseDuration)
        _this.elementObj.ElemChallenge.MaxFeedbackTime = parseFloat(this.covertMinsIntoHours(_this.ChallengeMaxFeedbackTimeValue))
        _this.elementObj.ElemChallenge.MaxAllocationTime = parseFloat(this.covertMinsIntoHours(_this.ChallengeMaxAllocationTimeValue))
        // AK: If Current challenge is Self/Teachback or selected as always assign coach then set by default MaxCoachAllocationTime as Null and set Allocate Manually as false
        if ((parseInt(this.ChallengeFeedbackTypeValue)) === constants.ChallengeFeedbackType.Self_Challenge || _this.ChallengeAlwaysAssignCoach || (parseInt(this.ChallengeSubTypeValue) === parseInt(constants.DescVideoType.Teachback))) {
          _this.elementObj.ElemChallenge.MaxCoachAllocationTime = null
          _this.elementObj.ElemChallenge.AllocateManually = false
          _this.elementObj.ElemChallenge.RequireFeedbackForCoachAllocation = false
        } else {
          if (_this.ChallengeMaxCoachAllocationTimeValue !== undefined && _this.ChallengeMaxCoachAllocationTimeValue !== null && _this.ChallengeMaxCoachAllocationTimeValue !== '' && _this.ChallengeMaxCoachAllocationTimeValue !== 'null') {
            _this.elementObj.ElemChallenge.MaxCoachAllocationTime = parseFloat(this.covertMinsIntoHours(_this.ChallengeMaxCoachAllocationTimeValue))
          } else {
            _this.elementObj.ElemChallenge.MaxCoachAllocationTime = null
          }
        }
        var fileUrl = null
        if ((parseInt(this.ChallengeSubTypeValue) === parseInt(constants.DescVideoType.Teachback))) {
          fileUrl = document.getElementById('toolkitfile').files[0]
          if (fileUrl === undefined || fileUrl === null || fileUrl === 'null') {
            fileUrl = null
          }
        }
        if ((parseInt(this.ChallengeFeedbackTypeValue)) === constants.ChallengeFeedbackType.Self_Challenge || this.ChallengeMinPeerForFeedbackValue === -1) {
          _this.elementObj.ElemChallenge.MinPeersForFeedback = null
        }
        var vttFileUrl = document.getElementById('vttFile').files[0]
        if (vttFileUrl === undefined && vttFileUrl === null) {
          vttFileUrl = null
        }
        const formData = new FormData()
        formData.append('ChallengeData', JSON.stringify(_this.elementObj))
        formData.append('File', fileUrl)
        formData.append('VttFileInput', vttFileUrl)
        elementService
          .createChallengeElement(storeObj.state.access_token, formData)
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Refresh Element List by emitting event (LessonListCreateElement option)
                _this.$emit('refreshElementList', true)
              } else {
                // AK: Hide Spinner
                _this.$emit('showSpinner', false)
                this.showAlertDialog = true
                this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            },
            errorObj => {
              // AK: Hide Spinner
              _this.$emit('showSpinner', false)
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'Selected ModuleId is NULL hence declined CREATE CHALLENGE ELEMENT OPERATION'
        )
      }
    },
    setDefaultValues: function () {
      this.elementObj.ModuleId = this.lessonObj.ModuleId
      this.covertHoursIntoMins()
    },
    covertHoursIntoMins: function () {
      var maxFeedbackTimeInHours = this.elementObj.ElemChallenge.MaxFeedbackTime
      this.elementObj.ElemChallenge.MaxFeedbackTime = maxFeedbackTimeInHours * 60
      // console.log('this.elementObj.ElemChallenge.MaxFeedbackTime >> ' + this.elementObj.ElemChallenge.MaxFeedbackTime)
      var maxAllocationTimeInHours = this.elementObj.ElemChallenge.MaxAllocationTime
      this.elementObj.ElemChallenge.MaxAllocationTime = maxAllocationTimeInHours * 60
      // console.log('this.elementObj.ElemChallenge.MaxAllocationTime >> ' + this.elementObj.ElemChallenge.MaxAllocationTime)
    },
    covertMinsIntoHours: function (minuteValue) {
      return (minuteValue / 60)
    },
    chekckToolkitFileExtesion: function (fileName) {
      var exts = ['.pdf']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    sortFeebackScreens: function () {
      var swapped
      do {
        swapped = false
        for (var i = 0; i < this.feedbackScreens.length - 1; i++) {
          if (this.feedbackScreens[i] > this.feedbackScreens[i + 1]) {
            var temp = this.feedbackScreens[i]
            this.feedbackScreens[i] = this.feedbackScreens[i + 1]
            this.feedbackScreens[i + 1] = temp
            swapped = true
          }
        }
      } while (swapped)
      return this.feedbackScreens.join(',')
    },
    validateRequiredFieldBeforeSubmit: function () {
      var regex = /^(?:([0-5]?\d):)?([0-5]?\d)$/g
      var vttFileUrl = document.getElementById('vttFile').files[0]
      if ((parseInt(this.ChallengeSubTypeValue) === parseInt(constants.DescVideoType.Teachback))) {
        var fileUrl = document.getElementById('toolkitfile').files[0]
      }
      var isNonNumeric = /[^$,.\d]/
      if (this.ChallengeTitleValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        return false
      } else if (this.allowedResponseTypeArr.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select at least one response type.'
        return false
      } else if ((this.ChallengeDurationValue.trim().length !== 0 && this.ChallengeDurationValue.indexOf(':') === -1)) {
        this.showAlertDialog = true
        this.errorMsg = 'Duration format should be MM:SS.'
        return false
      } else if (this.ChallengeIncludeInProgress && this.ChallengeDurationValue.trim().length > 0 && !regex.test(this.ChallengeDurationValue)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please enter a valid duration.'
        return false
      } else if (this.LowVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.LowVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.LowVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Low Quality Faculty Video url.'
        return false
      } else if (this.VideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.VideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.VideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Auto Quality Faculty Video url.'
        return false
      } else if (this.HDVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.HDVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.HDVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid High Quality Faculty Video url.'
        return false
      } else if (this.ChallengeIdValue === '-1') {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a challenge.'
        return false
      } else if (this.ChallengeFeedbackTypeValue === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select the feedback type.'
        return false
      } else if (vttFileUrl !== undefined && vttFileUrl !== null && !this.checkVttFileExtesion(document.getElementById('vttFile').value)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a valid .vtt file for caption.'
        return false
      } else if ((vttFileUrl !== undefined && vttFileUrl !== null && !this.checkVttFileExtesion(document.getElementById('vttFile').value)) && ((this.VideoURLValue.trim().length === 0))) {
        this.showAlertDialog = true
        this.errorMsg = 'Auto Quality Faculty Video url is required in order to upload caption file.'
        return false
      } else if (this.feedbackScreens.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'No feedback screen(s) selected.'
        return false
      } else if (this.ChallengeSubTypeValue === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please Select Sub Type.'
        return false
      } else if ((parseInt(this.ChallengeSubTypeValue) === parseInt(constants.DescVideoType.Teachback)) && ((this.elementObj.Description === undefined) || (this.elementObj.Description === null)) && fileUrl === undefined) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add a teachback description.'
        return false
      } else if ((parseInt(this.ChallengeSubTypeValue) === parseInt(constants.DescVideoType.Teachback)) && (this.elementObj.Description !== undefined) && (this.elementObj.Description !== null) && fileUrl !== undefined) {
        this.showAlertDialog = true
        this.errorMsg = 'Teachback description can either be in Text or PDF format.'
        return false
      } else if ((parseInt(this.ChallengeSubTypeValue) === parseInt(constants.DescVideoType.Teachback)) && fileUrl !== undefined && !this.chekckToolkitFileExtesion(document.getElementById('toolkitfile').value)) {
        this.showAlertDialog = true
        this.errorMsg = 'Invalid file format detected. You need to use a .pdf file for teachback description.'
        return false
      } else if ((parseInt(this.ChallengeSubTypeValue) === parseInt(constants.DescVideoType.Normal)) && (!this.hasAutoFacultyVideoUrlsPresent())) {
        this.showAlertDialog = true
        this.errorMsg = 'Auto Quality Video url is required in \'' + this.getChallengeName() + '\' challenge.'
        return false
      } else if (this.ChallengeResponseDurationValue === null || this.ChallengeResponseDurationValue === undefined || this.ChallengeResponseDurationValue === 'null' || this.ChallengeResponseDurationValue === '') {
        this.showAlertDialog = true
        this.errorMsg = 'Response duration can\'t be empty.'
        return false
      } else if ((isNaN(parseFloat(this.ChallengeResponseDurationValue))) || this.ChallengeResponseDurationValue.match(isNonNumeric)) {
        this.showAlertDialog = true
        this.errorMsg = 'Response duration time must be a whole numeric value.'
        return false
      } else if ((this.ChallengeResponseDurationValue.indexOf('.') >= 0)) {
        this.showAlertDialog = true
        this.errorMsg = 'Response duration must be a whole numeric value.'
        return false
      } else if (parseFloat(this.ChallengeResponseDurationValue) <= 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Response duration should be greater than 0.'
        return false
      } else if (parseFloat(this.ChallengeResponseDurationValue) > 5) {
        this.showAlertDialog = true
        this.errorMsg = 'Response duration should not be greater than 5.'
        return false
      } else if (this.ChallengeFeedbackTypeValue === constants.ChallengeFeedbackType.Regular_Challenge) {
        // var isNonNumeric = /[^$,.\d]/
        if (this.ChallengeMaxAllocationTimeValue === null || this.ChallengeMaxAllocationTimeValue === undefined || this.ChallengeMaxAllocationTimeValue === 'null' || this.ChallengeMaxAllocationTimeValue === '') {
          this.showAlertDialog = true
          this.errorMsg = 'Max allocation time can\'t be empty.'
          return false
        } else if ((isNaN(parseFloat(this.ChallengeMaxAllocationTimeValue))) || this.ChallengeMaxAllocationTimeValue.match(isNonNumeric)) {
          this.showAlertDialog = true
          this.errorMsg = 'Max allocation time must be a whole numeric value.'
          return false
        } else if ((this.ChallengeMaxAllocationTimeValue.indexOf('.') >= 0)) {
          this.showAlertDialog = true
          this.errorMsg = 'Max allocation time must be a whole numeric value.'
          return false
        } else if (parseFloat(this.ChallengeMaxAllocationTimeValue) <= 0) {
          this.showAlertDialog = true
          this.errorMsg = 'Max allocation time should be greater than 0.'
          return false
        } else if (parseFloat(this.ChallengeMaxAllocationTimeValue) > 43800) {
          this.showAlertDialog = true
          this.errorMsg = 'Max allocation time should not be greater than 43800 mins.'
          return false
        } else if (this.ChallengeMaxFeedbackTimeValue === null || this.ChallengeMaxFeedbackTimeValue === undefined || this.ChallengeMaxFeedbackTimeValue === 'null' || this.ChallengeMaxFeedbackTimeValue === '') {
          this.showAlertDialog = true
          this.errorMsg = 'Max feedback time can\'t be empty.'
          return false
        } else if ((isNaN(parseFloat(this.ChallengeMaxFeedbackTimeValue))) || (this.ChallengeMaxFeedbackTimeValue.indexOf('.') >= 0) || this.ChallengeMaxFeedbackTimeValue.match(isNonNumeric)) {
          this.showAlertDialog = true
          this.errorMsg = 'Max feedback time must be a whole numeric value.'
          return false
        } else if (parseFloat(this.ChallengeMaxFeedbackTimeValue) <= 0) {
          this.showAlertDialog = true
          this.errorMsg = 'Max feedback time should be greater than 0.'
          return false
        } else if (parseFloat(this.ChallengeMaxFeedbackTimeValue) > 43800) {
          this.showAlertDialog = true
          this.errorMsg = 'Max feedback time should not be greater than 43800 mins.'
          return false
        } else if (this.ChallengeMaxPeerAllocationValue === -1) {
          this.showAlertDialog = true
          this.errorMsg = 'Please select max peer allocation.'
          return false
        } else if ((this.ChallengeMaxCoachAllocationTimeValue !== undefined && this.ChallengeMaxCoachAllocationTimeValue !== null && this.ChallengeMaxCoachAllocationTimeValue !== '' && this.ChallengeMaxCoachAllocationTimeValue !== 'null') && ((isNaN(parseFloat(this.ChallengeMaxCoachAllocationTimeValue))) || this.ChallengeMaxCoachAllocationTimeValue.match(isNonNumeric))) {
          this.showAlertDialog = true
          this.errorMsg = 'Max coach allocation time must be a whole numeric value.'
          return false
        } else if ((this.ChallengeMaxCoachAllocationTimeValue !== undefined && this.ChallengeMaxCoachAllocationTimeValue !== null && this.ChallengeMaxCoachAllocationTimeValue !== '' && this.ChallengeMaxCoachAllocationTimeValue !== 'null') && (this.ChallengeMaxCoachAllocationTimeValue.indexOf('.') >= 0)) {
          this.showAlertDialog = true
          this.errorMsg = 'Max coach allocation time must be a whole numeric value.'
          return false
        } else if ((this.ChallengeMaxCoachAllocationTimeValue !== undefined && this.ChallengeMaxCoachAllocationTimeValue !== null && this.ChallengeMaxCoachAllocationTimeValue !== '' && this.ChallengeMaxCoachAllocationTimeValue !== 'null') && (parseFloat(this.ChallengeMaxCoachAllocationTimeValue) <= 0)) {
          this.showAlertDialog = true
          this.errorMsg = 'Max coach allocation time should be greater than 0.'
          return false
        }
      }
      return true
    },
    getCurrentChallengeObj: function () {
      var selectedChallengeObj = null
      var challengeList = this.$store.state.challengeList
      var _this = this
      selectedChallengeObj = challengeList.filter(function (item) {
        return item.ChallengeId === _this.ChallengeIdValue
      })
      return selectedChallengeObj[0]
    },
    hasAutoFacultyVideoUrlsPresent: function () {
      var currSelectedChallengeObj = this.getCurrentChallengeObj()
      return ((currSelectedChallengeObj !== null && currSelectedChallengeObj !== undefined) && (currSelectedChallengeObj.VideoUrl !== null && currSelectedChallengeObj.VideoUrl !== undefined))
    },
    getChallengeName: function () {
      var currSelectedChallengeObj = this.getCurrentChallengeObj()
      if ((currSelectedChallengeObj !== null && currSelectedChallengeObj !== undefined) && (currSelectedChallengeObj.Title !== null && currSelectedChallengeObj.Title !== undefined)) {
        return currSelectedChallengeObj.Title
      } else {
        return ''
      }
    },
    ShowRtfEditorOverlayFlag (event, flagToUpdate) {
      // AK: Used when user pressed Edit Course details to open Edit Course Details overlay
      this.showRtfEditorDetails = flagToUpdate
      // AK: Disable Background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    updateShowRtfEditorFlag (value) {
      // AK: Used to close the Edit Course Overlay
      var closeOverlay = value.closeRtfEditorOverlay
      // var transcriptText = value.transcript
      this.elementObj.Description = value.transcript
      console.log(this.elementObj.Description)
      this.showRtfEditorDetails = closeOverlay
    },
    updateShowSpinnerFlag (value) {
      // this.showSpinner = value
      this.$store.state.isLoading = value
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    },
    GetLearningLevels: function () {
      // var _this = this
      var storeObj = this.$store
      elementService
      .getLearningLevels(storeObj.state.access_token)
      .then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // console.log('respond status', responseObj.data.CreatedTS)
          // this.learningLevelId = responseObj.data
          storeObj.state.learningLevelList = responseObj.data
        } else {
            //  Hide Spinner
            // _this.$emit('showSpinner', false)
          this.showAlertDialog = true
          this.errorMsg = 'Oops! Something went wrong. Please try again.'
        }
      }, errorObj => {
        //  Hide Spinner
        // _this.$emit('showSpinner', false)
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    },
    checkVttFileExtesion: function (fileName) {
      var exts = ['.vtt']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    }
  },
  computed: {
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    VideoURLValue: {
      get: function () {
        return this.videoUrlObj.VideoUrl
      },
      set: function (newValue) {
        this.videoUrlObj.VideoUrl = newValue
      }
    },
    HDVideoURLValue: {
      get: function () {
        return this.videoUrlObj.HDVideoUrl
      },
      set: function (newValue) {
        this.videoUrlObj.HDVideoUrl = newValue
      }
    },
    LowVideoURLValue: {
      get: function () {
        return this.videoUrlObj.LowQualityVideoUrl
      },
      set: function (newValue) {
        this.videoUrlObj.LowQualityVideoUrl = newValue
      }
    },
    ChallengeRequireFeedbackForCoachAllocationValue: {
      get: function () {
        return this.elementObj.ElemChallenge.RequireFeedbackForCoachAllocation
      },
      set: function (newValue) {
        if (newValue) {
          this.ChallengeAlwaysAssignCoach = false
        }
        this.elementObj.ElemChallenge.RequireFeedbackForCoachAllocation = newValue
      }
    },
    ChallengeTitleValue: {
      get: function () {
        return this.elementObj.Title
      },
      set: function (newValue) {
        this.elementObj.Title = newValue
      }
    },
    CheckAllowedResponseTypeValue: {
      get: function () {
        return this.allowedResponseTypeArr
      },
      set: function (newValue) {
        this.allowedResponseTypeArr = newValue
      }
    },
    ChallengeIndexValue: {
      get: function () {
        return this.elementObj.Index
      },
      set: function (newValue) {
        if (newValue.trim() !== '') {
          var isNonNumeric = /[^$,.\d]/
          var nonNumericResult = newValue.match(isNonNumeric)
          if (!nonNumericResult) {
            if (parseInt(newValue) >= 1000) {
              this.errorMsg = 'Index should be less than 1000.'
              this.showAlertDialog = true
              this.elementObj.Index = null
            } else {
              this.elementObj.Index = parseInt(newValue)
            }
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Index must be a positive numeric value.'
            this.elementObj.Index = null
          }
        } else {
          this.elementObj.Index = null
        }
      }
    },
    ChallengeDurationValue: {
      get: function () {
        return this.elementObj.Duration
      },
      set: function (newValue) {
        this.elementObj.Duration = newValue
      }
    },
    FacultyResponseVideoUrlValue: {
      get: function () {
        return this.elementObj.ElemChallenge.FacultyResponseVideoUrl
      },
      set: function (newValue) {
        this.elementObj.ElemChallenge.FacultyResponseVideoUrl = newValue
      }
    },
    FacultyResponseLQVideoUrlValue: {
      get: function () {
        return this.elementObj.ElemChallenge.FacultyResponseLQVideoUrl
      },
      set: function (newValue) {
        this.elementObj.ElemChallenge.FacultyResponseLQVideoUrl = newValue
      }
    },
    FacultyResponseHDVideoUrlValue: {
      get: function () {
        return this.elementObj.ElemChallenge.FacultyResponseHDVideoUrl
      },
      set: function (newValue) {
        this.elementObj.ElemChallenge.FacultyResponseHDVideoUrl = newValue
      }
    },
    ChallengeIdValue: {
      get: function () {
        return this.elementObj.ElemChallenge.ChallengeId
      },
      set: function (newValue) {
        this.elementObj.ElemChallenge.ChallengeId = newValue
      }
    },
    ChallengeFeedbackTypeValue: {
      get: function () {
        return this.elementObj.ElemChallenge.FeedbackType
      },
      set: function (newValue) {
        if (newValue !== '') {
          this.elementObj.ElemChallenge.FeedbackType = parseInt(newValue)

          // AK: If challenge is self and user selected 3 type also then remove it from feedback screen
          if (this.elementObj.ElemChallenge.FeedbackType === constants.ChallengeFeedbackType.Self_Challenge) {
            if (this.feedbackScreens.indexOf(3) > -1 || this.feedbackScreens.indexOf('3') > -1) {
              const indexToBeRemoved = this.feedbackScreens.indexOf(3)
              this.feedbackScreens.splice(indexToBeRemoved, 1)
            }
            // AK: reset values to empty again for self challenge
            this.elementObj.ElemChallenge.MaxAllocationTime = ''
            this.elementObj.ElemChallenge.MaxFeedbackTime = ''
            this.elementObj.ElemChallenge.MaxCoachAllocationTime = ''
            this.elementObj.ElemChallenge.AlwaysAssignCoach = false
            this.elementObj.ElemChallenge.MaxPeerAllocations = -1
            this.elementObj.ElemChallenge.MinPeersForFeedback = -1
            this.elementObj.ElemChallenge.AllocateManually = false
            this.elementObj.ElemChallenge.RequireFeedbackForCoachAllocation = false
          } else {
            // AK: show default values again for regular challenge
            this.elementObj.ElemChallenge.MaxAllocationTime = '1440'
            this.elementObj.ElemChallenge.MaxFeedbackTime = '1440'
            this.elementObj.ElemChallenge.MaxCoachAllocationTime = ''
            this.elementObj.ElemChallenge.AlwaysAssignCoach = false
            // this.covertHoursIntoMins()
            this.elementObj.ElemChallenge.MaxPeerAllocations = 1
            this.elementObj.ElemChallenge.MinPeersForFeedback = 1
            this.elementObj.ElemChallenge.AllocateManually = false
            this.elementObj.ElemChallenge.RequireFeedbackForCoachAllocation = false
            this.feedbackScreens = [1, 2, 3]
          }
        } else {
          this.elementObj.ElemChallenge.FeedbackType = null
        }
      }
    },
    ChallengeSubTypeValue: {
      get: function () {
        return this.elementObj.SubType
      },
      set: function (newValue) {
        if (newValue !== '') {
          this.elementObj.SubType = parseInt(newValue)
        } else {
          this.elementObj.SubType = -1
        }
      }
    },
    ChallengeResponseDurationValue: {
      get: function () {
        return this.elementObj.ElemChallenge.ResponseDuration
      },
      set: function (newValue) {
        if (newValue !== '') {
          this.elementObj.ElemChallenge.ResponseDuration = newValue
        } else {
          this.elementObj.ElemChallenge.ResponseDuration = null
        }
      }
    },
    ChallengeFeedbackScreenValue: {
      get: function () {
        return this.elementObj.ElemChallenge.FeedbackScreens
      },
      set: function (newValue) {
        this.elementObj.ElemChallenge.FeedbackScreens = newValue
      }
    },
    ChallengeMaxAllocationTimeValue: {
      get: function () {
        return this.elementObj.ElemChallenge.MaxAllocationTime
      },
      set: function (newValue) {
        if (newValue !== '') {
          this.elementObj.ElemChallenge.MaxAllocationTime = newValue
        } else {
          this.elementObj.ElemChallenge.MaxAllocationTime = null
        }
      }
    },
    ChallengeMaxFeedbackTimeValue: {
      get: function () {
        return this.elementObj.ElemChallenge.MaxFeedbackTime
      },
      set: function (newValue) {
        if (newValue !== '') {
          this.elementObj.ElemChallenge.MaxFeedbackTime = newValue
        } else {
          this.elementObj.ElemChallenge.MaxFeedbackTime = null
        }
      }
    },
    ChallengeMaxCoachAllocationTimeValue: {
      get: function () {
        return this.elementObj.ElemChallenge.MaxCoachAllocationTime
      },
      set: function (newValue) {
        if (newValue !== '') {
          this.elementObj.ElemChallenge.MaxCoachAllocationTime = newValue
        } else {
          this.elementObj.ElemChallenge.MaxCoachAllocationTime = null
        }
      }
    },
    ChallengeMaxPeerAllocationValue: {
      get: function () {
        return this.elementObj.ElemChallenge.MaxPeerAllocations
      },
      set: function (newValue) {
        if (newValue !== '') {
          if (this.elementObj.ElemChallenge.MinPeersForFeedback <= newValue) {
            this.elementObj.ElemChallenge.MaxPeerAllocations = parseInt(newValue)
          } else {
            this.errorMsg = 'Max peer allocation can\'t be less than Min peer for feedback'
            this.showAlertDialog = true
          }
        } else {
          this.elementObj.ElemChallenge.MaxPeerAllocations = 1
        }
      }
    },
    ChallengeAllocateManuallyFlag: {
      get: function () {
        return this.elementObj.ElemChallenge.AllocateManually
      },
      set: function (newValue) {
        if (newValue) {
          this.allowedResponseTypeArr = [0, 1, 2]
          this.ChallengeRequireFeedbackForCoachAllocationValue = false
          if (this.ChallengeMaxPeerAllocationValue === -1) {
            this.ChallengeMaxPeerAllocationValue = 1
          }
          this.elementObj.ElemChallenge.MaxCoachAllocationTime = null
          this.ChallengeMinPeerForFeedbackValue = 1
        } else {
          this.allowedResponseTypeArr = [0]
        }
        this.elementObj.ElemChallenge.AllocateManually = newValue
      }
    },
    ChallengeMinPeerForFeedbackValue: {
      get: function () {
        return this.elementObj.ElemChallenge.MinPeersForFeedback
      },
      set: function (newValue) {
        if (newValue !== '') {
          if (newValue <= this.elementObj.ElemChallenge.MaxPeerAllocations) {
            this.elementObj.ElemChallenge.MinPeersForFeedback = parseInt(newValue)
          } else {
            this.errorMsg = 'Min peers for feedback can\'t be greater than Max peer allocation'
            this.showAlertDialog = true
          }
        } else {
          this.elementObj.ElemChallenge.MinPeersForFeedback = 1
        }
      }
    },
    ChallengeIncludeInProgress: {
      get: function () {
        return this.elementObj.IncludeInProgress
      },
      set: function (newValue) {
        this.elementObj.IncludeInProgress = newValue
      }
    },
    ChallengeAlwaysAssignCoach: {
      get: function () {
        return this.elementObj.ElemChallenge.AlwaysAssignCoach
      },
      set: function (newValue) {
        if (newValue) {
          this.ChallengeMaxCoachAllocationTimeValue = ''
          this.ChallengeAllocateManuallyFlag = false
          this.ChallengeRequireFeedbackForCoachAllocationValue = false
        }
        this.elementObj.ElemChallenge.AlwaysAssignCoach = newValue
      }
    },
    getVideoUrlValue: {
      get: function () {
        return this.VideoUrl
      }
    },
    AddDescriptionvalue: {
      get: function () {
        // console.log(JSON.stringify(this.elementObj))
        return this.elementObj.Description
      }
    },
    elementLearningLevelObjValue: {
      get: function () {
        console.log('Learning Object value', this.elementObj.LearningLevelId)
        if (this.elementObj.LearningLevelId !== undefined && this.elementObj.LearningLevelId !== null && this.elementObj.LearningLevelId !== '' && this.elementObj.LearningLevelId !== 'null') {
          return this.elementObj.LearningLevelId
        } else {
          return -1
        }
      },
      set: function (newValue) {
        this.elementObj.LearningLevelId = newValue
      }
    },
    getLearningLevelList: {
      get: function () {
        // console.log('Learning List ++', this.$store.learningLevelList)
        return this.$store.state.learningLevelList
      }
    },
    MCQIsPersonalization: {
      get: function () {
        return this.elementObj.IsPersonalization
      },
      set: function (newValue) {
        this.elementObj.IsPersonalization = newValue
      }
    }
  },
  watch: {}
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 13%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-0Point5Perc {
  margin-bottom: 0.5%;
}
.margin-bottom-1Perc {
  margin-bottom: 1%;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.margin-bottom-1Point5Perc {
  margin-bottom: 1.5%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.padding-left-0px{
  padding-left:0px !important;
}
.margin-top-2Point4Perc{
  margin-top: 2.4% !important;
}
.create-lesson-label-text-style {
  color: #34495e;
  font-size: 12px;
}
.border-red{
  border: 1px solid red;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.margin-left-1Point6Perc
{
  margin-left:1.6%;
}
.margin-left-0px {
  margin-left:0px;
}
.margin-bottom-4point5px {
  margin-bottom:4.5px;
}
.text-vertical-center {
  text-align: center;
}
.padding-top-bottom-69px {
  padding: 69px 0;
}
.height-152point8px {
  height: 152.8px;
}
.border-light-grey {
 border: 1px solid #d6d6d6;
}
.background-color {
  background-color: #eee;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-default {
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/CreateChallengeElement.vue